module.exports = __webpack_public_path__ + "static/img/chemistry2.b4fee4ae.png";